<!-- Background -->
  <div class="bg">
    <img src="../../../../assets/img/background_simulabox.svg" alt="background"/>
  </div>

  <div class="card-wrapper">
    <!-- Logo -->
    <div class="logo">
      <img src="../../../../assets/icons/Logomini.png" alt="logo"/>
    </div>

    <!-- Connexion card -->
    <form
        class="login-card"
        [formGroup]="restForm"
        (ngSubmit)="sendResetPassword()">
      <h1>Mot de passe oublié</h1>

      <!-- Email -->
      <div class="input-row">
        <svg class="icon" width="18" height="18" viewBox="0 0 24 24" fill="none"
          stroke="#3b7dd8" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <rect x="2" y="4" width="20" height="16" rx="3"/>
          <path d="m2 7 10 7 10-7"/>
        </svg>

        <input
            type="email"
            [placeholder]="'AUTH.ENTER_EMAIL' | translate"
            formControlName="email"
            required/>
      </div>

      <button class="btn-primary">Mot de passe oublié</button>
      <a class="link" routerLink="/auth/signin">{{
            "AUTH.SIGN_IN" | translate
        }}</a>
    </form>

    <!-- Footer -->
    <div class="footer">
      <svg width="14" height="14" viewBox="0 0 24 24" fill="none"
        stroke="#3b7dd8" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <rect x="2" y="4" width="20" height="16" rx="3"/>
        <path d="m2 7 10 7 10-7"/>
      </svg>
      <a href="mailto:support@simulabox.fr">support@simulabox.fr</a>
    </div>
  </div>